import { t } from '@lingui/core/macro';

import type { CmdbCardRow } from '../../lib/types';

/** Classes with an SBOM upload action (DEV-107). */
export const SBOM_UPLOAD_CLASSES = new Set(['ProduktType', 'ProduktVersion', 'ProduktInstanz']);

function referenceId(value: unknown): number | null {
  return typeof value === 'number' && Number.isInteger(value) ? value : null;
}

/**
 * Import page for an SBOM upload from this row, or null when there is none:
 * a product chooses its version there, an official version is preselected for
 * an update, and a custom version is only ever updated through its instance.
 */
export function sbomUploadLink(klass: string, row: CmdbCardRow): string | null {
  if (klass === 'ProduktType') return `/import?target=product&product=${row.id}`;
  if (klass === 'ProduktInstanz') return `/import?target=instance&instance=${row.id}`;
  if (klass !== 'ProduktVersion') return null;
  if (row.values.VersionType === 'CUSTOM') {
    const instance = referenceId(row.values.ProductInstanceID);
    return instance === null ? null : `/import?target=instance&instance=${instance}`;
  }
  const product = referenceId(row.values.ProduktTypeID);
  return product === null ? null : `/import?target=product&product=${product}&version=${row.id}`;
}

export function sbomUploadTitle(klass: string, row: CmdbCardRow): string {
  if (klass === 'ProduktInstanz') return t`Scan (SBOM) hochladen`;
  if (klass === 'ProduktVersion' && row.values.VersionType === 'CUSTOM') {
    return t`Scan der zugehörigen Produktinstanz hochladen`;
  }
  return t`SBOM hochladen`;
}
